import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { companyInfo } from "../data/mock";

export const ContactSection = () => {
  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#ff9900] font-semibold text-sm uppercase tracking-wider">
            Contact Us
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0a2a43] mt-3 mb-4">
            Get In Touch
          </h2>
          <p className="text-[#4a6680] max-w-2xl mx-auto text-lg">
            Have questions about our products or services? Reach out to us and we'll get back to you promptly.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
  {/* Contact Info Cards */}
  <div className="space-y-5">
    {[
      {
        Icon: MapPin,
        title: "Visit Us",
        detail: companyInfo.address,
        sub: "Open for walk-in consultations",
        link: "https://maps.app.goo.gl/52tqCqrh4BeJMhh3A",
        external: true,
      },
      {
        Icon: Phone,
        title: "Call Us",
        detail: companyInfo.phone,
        sub: "Mon-Sat, 9AM to 5:30PM",
        link: "tel:8700919798",
      },
      {
        Icon: Mail,
        title: "Email Us",
        detail: companyInfo.email,
        sub: "We reply within 24 hours",
        link: "mailto:aadelhi@hotmail.com",
      },
      {
        Icon: Clock,
        title: "Business Hours",
        detail: "Monday – Saturday",
        sub: "9:00 AM – 5:30 PM",
      },
    ].map(({ Icon, title, detail, sub, link, external }) => (
      <div
        key={title}
        className="flex items-start gap-5 p-5 rounded-2xl bg-[#f8fafc] border border-[#e2e8f0] hover:border-[#ff9900]/20 hover:shadow-md transition-all duration-300 group"
      >
        {/* Clickable Icon */}
        {link ? (
          <a
            href={link}
            target={external ? "_blank" : "_self"}
            rel="noopener noreferrer"
            className="w-12 h-12 rounded-xl bg-[#0a2a43] flex items-center justify-center flex-shrink-0 group-hover:bg-[#ff9900] transition-colors duration-300 cursor-pointer"
          >
            <Icon className="w-5 h-5 text-white" />
          </a>
        ) : (
          <div className="w-12 h-12 rounded-xl bg-[#0a2a43] flex items-center justify-center flex-shrink-0 group-hover:bg-[#ff9900] transition-colors duration-300">
            <Icon className="w-5 h-5 text-white" />
          </div>
        )}

        {/* Text (Not Clickable) */}
        <div>
          <h4 className="font-semibold text-[#0a2a43] mb-0.5">{title}</h4>
          <p className="text-[#4a6680] font-medium">{detail}</p>
          <p className="text-[#94a3b8] text-sm mt-0.5">{sub}</p>
        </div>
      </div>
    ))}
  </div>

  {/* Map */}
  <div className="rounded-2xl overflow-hidden border border-[#e2e8f0] shadow-sm h-[400px] lg:h-full min-h-[400px]">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.01805607888!2d77.23520901164103!3d28.509104475631244!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd309eebed77%3A0xa4becd45997cbeda!2sAdvanced%20Automation%20-%20Digital%20Level%20Indicator!5e0!3m2!1sen!2sus!4v1771690550675!5m2!1sen!2sus"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="Advanced Automation Location"
    />
  </div>
</div>
      </div>
    </section>
  );
};
